import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldConfigurationComponent } from './field-configuration/field-configuration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedUtilitiesModule } from '../../../utilities/shared-utilities.module';


@NgModule({
  declarations: [
    FieldConfigurationComponent
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule
  ]
})
export class FieldConfigurationModule { }
